(function () {
  var STORAGE_KEY = 'geo_modal_dismissed';
  var TTL = 7 * 24 * 60 * 60 * 1000;

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function isDismissed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      return Date.now() - parseInt(raw, 10) < TTL;
    } catch (e) {
      return false;
    }
  }

  function setDismissed() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }

  function showModal(modal, distanceKm) {
    if (distanceKm != null) {
      var distEl = modal.querySelector('[data-geo-distance]');
      if (distEl) {
        var km = distanceKm < 1
          ? (distanceKm * 1000).toFixed(0) + ' m od Ciebie'
          : distanceKm.toFixed(1).replace('.', ',') + ' km od Ciebie';
        distEl.textContent = km;
        distEl.classList.remove('geo-modal__distance--hidden');
      }
    }
    modal.style.cssText = 'display:flex!important;position:fixed!important;top:0!important;right:0!important;bottom:0!important;left:0!important;z-index:9999!important;align-items:center!important;justify-content:center!important;padding:16px!important;';
    modal.classList.remove('geo-modal--hidden');
    modal.classList.add('geo-modal--visible');
    document.body.style.overflow = 'hidden';
    if (typeof gtag === 'function') {
      gtag('event', 'geo_modal_shown', {
        distance_km: distanceKm != null ? parseFloat(distanceKm.toFixed(1)) : null
      });
    }
  }

  function hideModal(modal) {
    setDismissed();
    modal.style.cssText = 'display:none!important;';
    modal.classList.remove('geo-modal--visible');
    modal.classList.add('geo-modal--hidden');
    document.body.style.overflow = '';
  }

  var DEV_MODE = false;

  function init() {
    var modal = document.getElementById('geo-modal');
    if (!modal) return;
    if (!DEV_MODE && isDismissed()) return;
    if (!DEV_MODE && !navigator.geolocation) return;

    var closeBtn = document.getElementById('geo-modal-close');
    var overlay  = document.getElementById('geo-modal-overlay');

    function onDismiss(source) {
      hideModal(modal);
      if (typeof gtag === 'function') gtag('event', 'geo_modal_dismissed', { source: source });
    }
    if (closeBtn) closeBtn.addEventListener('click', function () { onDismiss('close_button'); });
    if (overlay)  overlay.addEventListener('click', function () { onDismiss('overlay'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('geo-modal--visible')) onDismiss('escape');
    });

    var ctaBtn = modal.querySelector('.geo-modal__cta');
    if (ctaBtn) ctaBtn.addEventListener('click', function () {
      if (typeof gtag === 'function') gtag('event', 'geo_modal_cta_click');
    });

    if (DEV_MODE) {
      setTimeout(function () { showModal(modal); }, 1500);
      return;
    }

    var storeLat = parseFloat(modal.dataset.lat);
    var storeLng = parseFloat(modal.dataset.lng);
    var radius   = parseFloat(modal.dataset.radius) || 15;

    setTimeout(function () {
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var dist = haversineKm(pos.coords.latitude, pos.coords.longitude, storeLat, storeLng);
          if (dist <= radius) {
            showModal(modal, dist);
          } else {
            if (typeof gtag === 'function') gtag('event', 'geo_outside_radius', {
              distance_km: parseFloat(dist.toFixed(1))
            });
          }
        },
        function () {
          if (typeof gtag === 'function') gtag('event', 'geo_permission_denied');
        },
        { timeout: 8000, maximumAge: 300000 }
      );
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
